import React, { useEffect, useState } from 'react'
import './player-list-mobile.styles.scss'
import { sortPlayers } from '@/utils/sortPlayers';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { formatNumber } from '@/utils/formatNumber';
import { useNavigate } from 'react-router-dom';

const PlayerListMobile = ({
    gameData,
    sortedPlayers, 
    gameElements,
    showAliases
}) => {

    const [ sortBy, setSortBy ] = useState('name');
    const [ playersToDisplay, setPlayersToDisplay ] = useState([]);
    const [ sortList ] = useState([
        { value: 'name', label: 'Display Name' },
        { value: 'points', label: 'Total Points' },
        { value: 'level', label: 'Level' },
        { value: 'currency', label: 'Current Balance' },
        { value: 'currencyTotal', label: 'Total Currency Earned'},
        { value: 'badges', label: 'Badges Earned' },
        { value: 'items', label: 'Current Items' },
        { value: 'codes', label: 'Secret Codes Found' },
        { value: 'challenges', label: 'Challenges Approved' }
    ]);
    const [ tableHeight, setTableHeight ] = useState(100);
    const navigate = useNavigate();

    useEffect(() => {
        if (!sortedPlayers) return;
        let sort = sortBy;
        if (sortBy === 'level') {
            sort = 'points'
        }
        setPlayersToDisplay(
            sortPlayers({
                'playerList': sortedPlayers,
                'sortBy': sort,
                'filter': 'player'
            })
        );
        const playersCard = document.querySelector('.players-card');
        if (!playersCard) return;
        const playersCardHeight = playersCard.offsetHeight;
        const cardTitle = document.querySelector('.card-title');
        if (!cardTitle) return;
        const cartTitleHeight = cardTitle.offsetHeight;
        setTableHeight(playersCardHeight - cartTitleHeight - 200); // 50px for padding and margins
    }, [sortBy, sortedPlayers])

    function goToPlayerPage(path) {
        const row = document.getElementById('row-' + path);
        row.style.backgroundColor = 'var(--fourth-color)';
        const timeout = setTimeout(() => {
            clearTimeout(timeout);
            navigate(path);
        }, 100);
    }

    return (
        <div className='player-list-mobile'>
            <div className='field small inline'>
                <label>
                    Sort By
                </label>
                <select
                    className='sort-select'
                    onChange={(e) => setSortBy(e.target.value)}
                    value={sortBy}>
                    {
                        sortList.map((option) => {
                            return (
                                <option
                                    key={option.value}
                                    value={option.value}
                                    className='no-default'>
                                    {option.label}
                                </option>
                            )
                        })
                    }
                </select>
            </div>
            <div className="g-space-1"></div>
            <div 
                className='table-container'
                style={{ height: tableHeight + 'px' }}>
            {
                (playersToDisplay && gameData) &&
                <table className='g-table player-list-table'>
                    <thead>
                        <tr>
                            <th>Player Name</th>
                            <th>Data</th>
                        </tr>    
                    </thead>    
                    <tbody>
                        {
                            playersToDisplay.map((player, index) => {
                                let playerLevel;
                                if (player.levels && gameElements) {
                                    const lastLevel = Object.values(player.levels).sort((a,b) => a.ts < b.ts ? 1 : -1)[0]
                                    playerLevel = gameElements[lastLevel.id];
                                } else if (gameElements) {
                                    const levels = Object.values(gameElements)
                                    .filter(e => e.type === 'level' && e.status === 'active')
                                    .sort((a,b) => a.opt_pointMinimum > b.opt_pointMinimum ? 1 : -1)
                                    for (let l of levels) {
                                        if (player.points >= l.opt_pointMinimum) {
                                            playerLevel = l;
                                        }
                                    }
                                }
                                return (
                                    <tr
                                        key={player.playerId}
                                        className='player-list-item'
                                        onClick={() => goToPlayerPage(player.path)}
                                        id={'row-' + player.path}>
                                        <td>{
                                            showAliases
                                            ?
                                            player.alias
                                            :
                                            `${player.fName} ${player.lName}`
                                            }</td>
                                        <td className='player-data'>
                                            
                                            {
                                                (
                                                    sortBy === 'points' ||
                                                    (
                                                        (
                                                            sortBy === 'name' ||
                                                            sortBy === 'alias'
                                                        ) &&
                                                        gameData.sortLeaders === 'points'
                                                    )
                                                ) &&
                                                <>
                                                <ImageContainer
                                                    src='/images/xp.png' />
                                                {formatNumber(player.points)}
                                                </>
                                            }
                                            {
                                                (sortBy === 'level') &&
                                                <>
                                                {
                                                    playerLevel ? 
                                                    <>
                                                        <ImageContainer 
                                                            src={playerLevel.icon} 
                                                            className='level-icon' 
                                                        />
                                                        <span className='meta'>
                                                            {playerLevel.name}
                                                        </span>
                                                    </> :
                                                    <span className='no-level'>No level</span>
                                                }
                                                </>
                                            }
                                            {
                                                (
                                                    sortBy === 'currency' ||
                                                    sortBy === 'currencyTotal' ||
                                                    (
                                                        (
                                                            sortBy === 'name' ||
                                                            sortBy === 'alias'
                                                        ) &&
                                                        gameData.sortLeaders === 'currency'
                                                    )
                                                ) &&
                                                <>
                                                <ImageContainer
                                                    src="/images/icons/coin.png" />
                                                    {
                                                        (
                                                            sortBy === 'currency' && 
                                                            player.currency
                                                        ) 
                                                        ? formatNumber(player.currency)
                                                        : (
                                                            sortBy === 'currencyTotal' && 
                                                            player.currencyTotal
                                                        )
                                                        ? formatNumber(player.currencyTotal)
                                                        : 0
                                                    }
                                                </>
                                            }
                                            {
                                                (sortBy === 'badges') &&
                                                <>
                                                <ImageContainer
                                                    src="/images/icons/badges.png" />
                                                {
                                                    player.badges 
                                                    ? formatNumber(Object.values(player.badges).length) 
                                                    : 0
                                                }
                                                </>
                                            }
                                            {
                                                (sortBy === 'items') &&
                                                <>
                                                <ImageContainer
                                                    src="/images/icons/items.png" />
                                                {
                                                    player.items ? 
                                                    formatNumber(
                                                        Object.values(player.items)
                                                        // .filter(i => 
                                                        //     gameElements[i.id].opt_itemType !== 'lottery' &&
                                                        //     gameElements[i.id].opt_itemType !== 'contribution' &&
                                                        //     gameElements[i.id].opt_itemType !== 'realworld' &&
                                                        //     gameElements[i.id].opt_itemType !== 'prizepack'
                                                        // )
                                                        .reduce((partialSum, a) => partialSum + a.count, 0) 
                                                    ) 
                                                    : 0
                                                }
                                                </>
                                            }
                                            {
                                                (sortBy === 'codes') &&
                                                <>
                                                <ImageContainer
                                                    src="/images/icons/secret2.png" />
                                                {
                                                    player.secretCodes ? formatNumber(Object.values(player.secretCodes).length) : 0}
                                                </>
                                            }
                                            {
                                                (sortBy === 'challenges') &&
                                                <>
                                                <ImageContainer
                                                    src="/images/icons/challenge.png" />
                                                {
                                                    player.challenges ? 
                                                    formatNumber(
                                                        Object.values(player.challenges)
                                                        .reduce((acc, item) => 
                                                            acc + item.count, 0
                                                        )
                                                    ) 
                                                    : 0
                                                }
                                                </> 
                                            }
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            }
            </div>
        </div>
    )
}

export default PlayerListMobile